import { Modal } from 'antd'
import ConfirmStatusModal from './ConfirmStatusModal'
import SendMailModal from './SendMailModal'

const ContactModal = ({ handleCancel, isModalOpen, refetch, selectRecord, mode }) => {
    const render = () => {
        switch (mode) {
            case "status":
                return <ConfirmStatusModal selectRecord={selectRecord} refetch={refetch} handleCancel={handleCancel} />
            case "send_email":
                return <SendMailModal selectRecord={selectRecord} refetch={refetch} handleCancel={handleCancel} />
        }
    }

    return (
        <Modal
            title={mode === "status" ? "Nội dung cập nhật" : "Phản hồi khiếu nại giao dịch"}
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            closable={false}
            maskClosable={false}

        >
            {render()}
        </Modal>
    )
}

export default ContactModal